import { useState } from 'react';
import { BUNDLE_PRODUCT } from '../../utils/constants';
import SingleRow from './SingleRow';
import { jsx as _jsx } from "react/jsx-runtime";
const BundleRows = ({
  rowsData
}) => {
  const [expandedRow, setExpandedRow] = useState(null);
  return /*#__PURE__*/_jsx("div", {
    "data-testid": `${BUNDLE_PRODUCT}-rows`,
    children: rowsData.map(singleRowData => {
      const {
        rowIndex
      } = singleRowData;
      return /*#__PURE__*/_jsx(SingleRow, {
        isExpanded: expandedRow === rowIndex,
        setExpandedRow: setExpandedRow,
        singleRowData: singleRowData
      }, rowIndex);
    })
  });
};
export default BundleRows;
//# sourceMappingURL=BundleRows.js.map